import moment from 'moment';
import { defaultFormConfig } from './defaultPeriodTemplate';
import { defaultProgramHtml, getProgramHtml } from './defaultProgramHtml';
import { normalizeFormFields } from './fieldTypePresets';

export { getProgramHtml };

const MESSAGE_LABELS = {
  closed: 'Thông báo khi đợt đã đóng',
  closed_suffix: 'Hậu tố hiển thị hạn đăng ký (dùng {deadline})',
  success_title: 'Tiêu đề khi đăng ký thành công',
  success_subtitle: 'Mô tả khi đăng ký thành công',
  submit_button: 'Nút gửi biểu mẫu',
  register_success: 'Thông báo API khi lưu thành công',
  duplicate_citizen_id: 'Thông báo trùng CCCD',
  period_closed: 'Thông báo khi không thể đăng ký',
};

export { MESSAGE_LABELS };

export function apiItemToFormValues(item) {
  const program = JSON.parse(item.program_details || '{}');
  const examOptions = JSON.parse(item.exam_date_options || '[]');
  const formConfig = JSON.parse(item.form_config || '{}');

  return {
    code: item.code,
    title: item.title,
    intro: item.intro,
    registration_deadline: moment(item.registration_deadline),
    max_registrations: item.max_registrations,
    status: String(item.status),
    is_active: item.is_active === 1,
    program_html: getProgramHtml(program),
    exam_dates: examOptions.length
      ? examOptions.map((opt) => ({
          label: opt.label,
          date: moment(opt.value, 'YYYY-MM-DD'),
        }))
      : [{ label: '', date: null }],
    messages: { ...defaultFormConfig.messages, ...(formConfig.messages || {}) },
    form_fields: normalizeFormFields(
      formConfig.fields || defaultFormConfig.fields,
    ),
  };
}

export function formValuesToApiPayload(values, id) {
  const programDetails = {
    html: values.program_html || '',
  };

  const examDateOptions = (values.exam_dates || [])
    .filter((row) => row?.date && row?.label)
    .map((row) => ({
      value: moment(row.date).format('YYYY-MM-DD'),
      label: row.label,
    }));

  const formConfig = {
    messages: values.messages || {},
    fields: normalizeFormFields(values.form_fields || []),
  };

  return {
    id: id || '',
    code: values.code,
    title: values.title,
    intro: values.intro,
    registration_deadline: moment(values.registration_deadline).format(
      'YYYY-MM-DD HH:mm:ss',
    ),
    max_registrations:
      values.max_registrations === null || values.max_registrations === undefined
        ? ''
        : values.max_registrations,
    status: parseInt(values.status, 10),
    is_active: values.is_active ? 1 : 0,
    program_details: JSON.stringify(programDetails),
    exam_date_options: JSON.stringify(examDateOptions),
    form_config: JSON.stringify(formConfig),
  };
}

export function defaultFormValues() {
  return {
    status: '1',
    is_active: false,
    program_html: defaultProgramHtml,
    exam_dates: [{ label: '', date: null }],
    messages: { ...defaultFormConfig.messages },
    form_fields: normalizeFormFields(defaultFormConfig.fields),
  };
}
